import api from "./httpClient";
import { API_PATHS } from "./apiPaths";

export const getDiscountConfig = async () => {
  const resp = await api.get(API_PATHS.superAdmin.discountConfig());
  const data = resp?.data?.data ?? resp?.data ?? {};
  return {
    coupons: Array.isArray(data?.coupons) ? data.coupons : [],
    referralPercent: Number(data?.referralPercent ?? data?.referralDiscountPercent ?? 0) || 0,
  };
};

export const createCoupon = async ({ code, discountPercent } = {}) => {
  const payload = {
    code: String(code || "").trim().toUpperCase(),
    discountPercent: Number(discountPercent || 0),
  };
  const resp = await api.post(API_PATHS.superAdmin.createCoupon(), payload);
  return resp?.data?.data ?? resp?.data ?? null;
};

export const updateCouponStatus = async ({ couponId, active } = {}) => {
  const resp = await api.patch(API_PATHS.superAdmin.couponStatus(couponId), { active: Boolean(active) });
  return resp?.data?.data ?? resp?.data ?? null;
};

export const updateReferralPercent = async ({ referralPercent } = {}) => {
  const resp = await api.patch(API_PATHS.superAdmin.referralConfig(), {
    referralPercent: Number(referralPercent || 0),
  });
  return resp?.data?.data ?? resp?.data ?? null;
};
